import {
  traverseNode,
  isElementNode,
  isTextNode,
  isCommentNode,
  isChildOfElement,
  mergeSiblingTextNodes,
} from 'anodum';
import { constants } from '../classes/mutation-driver';
import mutation from '../../injections/bindings/mutation';
import instance from '../../instance';

const preserveTextElement = (element) => {
  const ignoredElements = [];

  traverseNode(element, (node) => {
    if (mutation.shouldIgnoreNode(node)) {
      mutation.remove(node);
      ignoredElements.push(node);
      return;
    }

    if (isElementNode(node) && !instance.driver.referenceMap.hasReference(node)) {
      mutation.preserve(node);
    }

    if (isTextNode(node)) {
      const isInsideIgnoredElement = ignoredElements.some((item) => isChildOfElement(node, item));
      if (isInsideIgnoredElement) return;

      mergeSiblingTextNodes(node);

      const sibling = node.previousSibling;
      const hasStaticToken =
        isCommentNode(sibling) && sibling.nodeValue === constants.STATIC_TEXT_TOKEN;

      if (!hasStaticToken) {
        mutation.preserve(node);
      }
    }
  });
};

export default preserveTextElement;
